import React from "react";
import WebImage from "../components/images/programmer.png";

const About = () => {
  return (
    <article className="mt-[9rem] max-lg:mt-[14rem] w-full pb-5" id="About">
      <div className="max-w-6xl  text-gray-400 px-4 mx-auto">
        <h1
          className="font-[200] text-[3rem] max-sm:text-[2rem] lg:text-left text-center"
          data-aos="slide-up"
          data-aos-duration="1000"
        >
          ABOUT ME
        </h1>
        <div className="h-auto text-white  flex max-lg:flex-col items-center justify-between">
          <section className="lg:w-1/2 w-full max-lg:text-center">
            <p
              className="text-center lg:text-left mb-3"
              data-aos="flip-left"
              data-aos-duration="1300"
            >
              I'm ABRAHAM COVENANT IGWE a Nigerian, i'm a Web Developer with
              proficiency in HTML , CSS, BOOTSTRAP, TAILWIND CSS, JAVASCRIPT,
              PHP, REACT and SOLIDITY programming languages, still aspiring and gasping in
              continues knowledge necessary for solution provision. My objective
              is to improve in knowledge and to work towards the
              advancement/continues achievement of my organization through the
              application of acquired skills; attaining set goals in a
              professional, competitive and changing environment!
            </p>
            <a
              href="mailto: abrahamcovenant2004@gmail.com"
              className="bg-blue-700 py-1 px-5 text-white rounded-sm border-none font-[300] mt-3 mb-5"
              data-aos="fade-up"
              data-aos-duration="1000"
            >
              HIRE ME
            </a>
          </section>
          <section
            className="lg:w-1/2 w-full flex lg:justify-end justify-center"
            data-aos="fade-up"
            data-aos-duration="1300"
          >
            <img
              src={WebImage}
              alt=""
              className="h-[17rem] max-sm:h-[13rem] max-lg:mt-11"
            />
          </section>
        </div>
      </div>
    </article>
  );
};

export default About;
